import {ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges} from '@angular/core';

@Component({
	selector: 'ic-fa-icon',
	template: `
		<i
			aria-hidden="true"
			matTooltipClass="pv-tooltip"
			matTooltipPosition="right"
			[class.fa-fw]="fixedWidth"
			[class.fa-spin]="loading"
			[matTooltip]="help"
			[matTooltipDisabled]="!help"
			[matTooltipShowDelay]="300"
			[ngClass]="extended ? 'fa fae-' + icon : 'fa fa-' + faIcon"
		>
		</i>
	`,
	styleUrls: ['./fa-icon-component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class FontAwesomeIconComponent implements OnChanges {
	@Input() icon: string;
	@Input() help?: string;
	@Input() extended = false;
	@Input() fixedWidth = true;
	@Input() loading = false;

	faIcon: string;

	ngOnChanges(changes: SimpleChanges) {
		if (changes.icon) {
			if (this.icon.indexOf('fae') !== -1) {
				this.extended = true;
			}

			if (this.icon) {
				this.faIcon = this.icon.replace(/(?:fa fa-|fa-|fae-|fa fae-)?(.*)/, '$1');

				return;
			}

			this.faIcon = null;
		}
	}
}
